import { connect } from 'react-redux';
import { showErrorFlag, showSuccessFlag } from '@helpCenter/state/actions/flags';
import LinkUnlinkProject from './link-unlink-project';

export default connect(null, {
    showErrorFlag,
    showSuccessFlag,
})(LinkUnlinkProject);
